import React from 'react';
import { inject, observer } from 'mobx-react';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import toNumber from 'lodash/toNumber';
import cloudImg from '../../style/img/cloud.png';
import storeImg from '../../style/img/store.png';
import logo from '../../style/img/logo.png';
import { LocaleProvider, Row, Col, Icon, Menu, Dropdown } from 'antd';
import navigations from './navigations';
import NavTop from './NavTop';
const SubMenu = Menu.SubMenu;
moment.locale('zh-cn');
const store = [
  'initStore',
  'ecodeDemoStore',
]
@inject(...store)
@observer
class Home extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      reload: true, //强制刷页面
      showSubMenu: false,
      openKeys: [],
      selectedKeys: [],
      height: 700,
      menuVisible: false,
      menuModuleStyle: {
        borderRadius: 0, marginLeft: -20, marginTop: -5, width: 150,
      },
    }
  }

  componentDidMount() {
    const { location } = this.props;
    const pathname = location.pathname.split('/');
    const pathnameLast = location.pathname ==="app/order" ? ['orderworkflow'] : [pathname[pathname.length - 1]];
    const openKey = location.query.id || location.pathname ==="app/order" ? pathname[pathname.length - 1] : pathname[pathname.length - 2];
    this.setState({
      openKeys: [openKey],
      selectedKeys: location.query.id ? [`${openKey}${location.query.id}`] : pathnameLast,
    });
    setInterval(() => {
      const { height } = this.state;
      const dom = document.getElementById('home-body-content');
      if (dom) {
        const domHeight = dom.clientHeight - 136;
        if (height !== domHeight) this.setState({ height: domHeight });
      }
    }, 200);
  }

  getMenuItem = (menu = []) => {
    const { location: { query }, initStore: { routing }, ecodeDemoStore: { initDatas } } = this.props;
    const me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
    const isAdmin = me.role === "admin";
    const content = menu.length > 0 ? menu.map(item => {
      let disabled = item.open === 'none' || (item.open === 'admin' && !isAdmin);
      if (item.needAuth) {
        const me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
        const r_id = me.member ? me.member.r_id : '0';
        disabled = toNumber(r_id) < 70;
      }
      if (item.subs) {
        return (
          <SubMenu key={item.key} mode="inline" title={item.name}>
            {this.getMenuItem(item.subs)}
          </SubMenu>
        )
      }
      return (<Menu.Item key={item.key} disabled={disabled} onClick={() => {
        this.setState({ selectedKeys: [item.key] }, () => {
          const itemQuery = item.query || {};
          item.open !== 'none' && routing.push({
            pathname: item.pathname,
            query: query.id ? { id: query.id, ...itemQuery } : itemQuery,
          });
          if (item.pathname.indexOf('ecodeDemo') >= 0) {
            initDatas(item.key);
          }
        });
      }}>{item.name}</Menu.Item>)
    }) : null;
    return content;
  }

  onOpenChange = (key) => {
    this.setState({ openKeys: key });
  }

  getMenuUser = (isLogin) => {
    const { menuModuleStyle } = this.state;
    const { initStore: { exit, routing } } = this.props;
    const menuUser = (
      <Menu style={menuModuleStyle}>
        <Menu.Item>
          <div className="menu-module" onClick={() =>  window.open(`${window.server}/web`)}>
            <Icon type="appstore" className="menu-module-icon" />
            <span className="menu-module-title">返回前台</span>
          </div>
        </Menu.Item>
        <Menu.Item>
          <div className="menu-module" onClick={() => {
            exit();
            routing.push('/login');
          }}>
            <Icon type="poweroff" className="menu-module-icon" />
            <span className="menu-module-title">退出</span>
          </div>
        </Menu.Item>
      </Menu>
    );
    return menuUser;
  }

  getPath = (item) => {
    if (item.subs) {
      return this.getPath(item.subs[0]);
    }
    return item.pathname;
  }
  render() {
    const { reload, selectedKeys, openKeys, height, menuVisible } = this.state;
    const { initStore } = this.props;
    let { routing, me } = initStore;

    //--------------------------------------登录-----------------------------------------------------//
    me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
    let isLogin = (me && null !== me.com && "" !== me.com && me.member && null !== me.member.m_name) ? true : false;
    //--------------------------------------------------------------------------------------------------//

    let pathname = window.location.href;
    pathname = '/' + pathname.substring(pathname.indexOf('#') + 1).split('/')[1];
    const navigationsSub = navigations.find(item => item.pathname === pathname);
    // const fullScreen = pathname === '/ecodeDemo';
    const fullScreen = true;
    return (
      <LocaleProvider locale={zhCN}>
        <div className='home'>
          <Row className='home-header'>
            <Col span={3} offset={fullScreen ? 1 : 2} className='home-cloudstore' onClick={() => {
              routing.push("/");
            }}>
              <div>
                <img src={cloudImg} style={{ marginRight: 12.7 }} alt='' />
                <img src={storeImg} alt='' />
              </div>
            </Col>
            <Col span={fullScreen ? 15 : 14} className='home-header-nav-top'>
              <NavTop datas={navigations} pathname={pathname}
                onClick={(route, item) => {
                  const defaultKey = item.defaultKey;
                  let path = item.pathname;
                  const sub = item.subs && item.subs.find(v => v.key === defaultKey);
                  let query = {};
                  if (sub) {
                    query = sub.query;
                    if (sub.subs) {
                      this.setState({ selectedKeys: [`${sub.subs[0].key}`], openKeys: [`${sub.key}`] });
                    }
                  } else {
                    path = this.getPath(item);
                    const pathRes = path.split('/').reverse();
                    this.setState({ selectedKeys: [pathRes[0]], openKeys: [pathRes[1]]});
                  }
                  routing.push({
                    pathname: sub ? route : path,
                    query,
                  });
                  this.setState({ reload });//强制刷新页面
                }}
                onMouseOver={() => this.setState({ showSubMenu: true })}
                onMouseOut={() => this.setState({ showSubMenu: false })} />
            </Col>
            <Col span={3} className='home-header-navigation text-elli'>
              {isLogin ? (
                <Dropdown overlay={this.getMenuUser(isLogin)} trigger={['click']} placement="bottomRight" visible={menuVisible}
                  onVisibleChange={(vis) => this.setState({ menuVisible: vis })}>
                  <span className={`login-con ant-dropdown-link${menuVisible ? '-active' : ''}`}>
                    <Icon type="user" />
                      <a className='login' title={me && me.member && me.member.m_name}>{me && me.member && me.member.m_name}</a>
                    <Icon type={menuVisible ? "up" : "down"} />
                  </span>
                </Dropdown>
              ) : (
                  <span style={{ display: 'inline-block', width: '110px' }}>
                    <a className='login'
                      onClick={() => routing.push('/login')}>登录</a>
                  </span>
                )}
            </Col>
          </Row>
          {
            fullScreen ? (
              <Row className="home-body home-body-fullScreen">
                <Col span={5} className="home-body-nav">
                  <div className="home-body-nav-title">
                    <span className={`home-body-nav-title-icon ${navigationsSub.icon}`} />
                    <span className="home-body-nav-title-span">{navigationsSub.name}</span>
                  </div>
                  <Menu mode="inline" selectedKeys={selectedKeys} openKeys={openKeys} onOpenChange={this.onOpenChange}>
                    {
                      navigationsSub && navigationsSub.subs && this.getMenuItem(navigationsSub.subs)
                    }
                  </Menu>
                </Col>
                <Col span={19} className="home-body-content" id="home-body-content">
                  {this.props.children}
                </Col>
              </Row>
            ) : (
              <Row className="home-body">
                <Col span={3} offset={2} className="home-body-nav" style={{ minHeight: height }}>
                  <div className="home-body-nav-title">
                    <span className={`home-body-nav-title-icon ${navigationsSub.icon}`} />
                    <span className="home-body-nav-title-span">{navigationsSub.name}</span>
                  </div>
                  <Menu mode="inline" selectedKeys={selectedKeys} openKeys={openKeys} onOpenChange={this.onOpenChange}>
                    {
                      navigationsSub && navigationsSub.subs && this.getMenuItem(navigationsSub.subs)
                    }
                  </Menu>
                </Col>
                <Col span={17} className="home-body-content" id="home-body-content">
                  {this.props.children}
                </Col>
              </Row>
            )
          }
          <div className='home-footter'>
            <Row>
              <Col span={6} offset={5}>
                <div className='home-footter-content'>
                  <img src={logo} alt='' />
                </div>
                <div className='home-footter-content'>
                  <Icon type="environment-o" className='home-footer-icon' />
                  <span className='home-footer-text'>上海市闵行区联航路1188号33号楼</span>
                </div>
                <div className='home-footter-content'>
                  <Icon type="mail" className='home-footer-icon' />
                  <span className='home-footer-text'>sales@weaver.com.cn</span>
                </div>
                <div className='home-footter-content'>
                  <Icon type="phone" className='home-footer-icon' />
                  <span className='home-footer-text'>021-68869298</span>
                </div>
              </Col>
              <Col span={4}>
                <div className='home-footter-content'>
                  <span className='home-footter-content-main'>关于云商店</span>
                </div>
                <div className='home-footter-content'>
                  <a href='https://www.e-cloudstore.com/#/?_k=s73jnm'>功能价值</a>
                </div>
                <div className='home-footter-content'>
                  <a href='/' target="_blank">价格体系</a>
                </div>
                <div className='home-footter-content'>
                  <a href='/' target="_blank">我们的服务</a>
                </div>
              </Col>
              <Col span={4}>
                <div className='home-footter-content'>
                  <span className='home-footter-content-main'>联系我们</span>
                </div>
                <div className='home-footter-content'>
                  <a href='' target="_blank">公司简介</a>
                </div>
                <div className='home-footter-content'>
                  <a href='/' target="_blank">产品特性</a>
                </div>
                <div className='home-footter-content'>
                  <a href='/' target="_blank">注册云商店</a>
                </div>
              </Col>
              <Col span={5}>
                <div className='home-footter-content'>
                  <span className='home-footter-content-main'>关于泛微</span>
                </div>
                <div className='home-footter-content'>
                  <a href='http://www.weaver.com.cn/'>泛微官网</a>
                </div>
                <div className='home-footter-content'>
                  <a href='/' target="_blank">产品方案</a>
                </div>
                <div className='home-footter-content'>
                  <a href='/' target="_blank">客户案例</a>
                </div>
                <div className='home-footter-content'>
                  <a href='/' target="_blank">服务中心</a>
                </div>
              </Col>
            </Row>
            <div className='copy-right'>
  						<p><a target="_blank" href="http://www.weaver.com.cn">版权所有：上海泛微网络科技股份有限公司</a></p>
	  					<p>Copyright © 2001-2021 Weaver Network All Rights Reserved.<a target="_blank" href="https://beian.miit.gov.cn">沪ICP备05040488号-11</a></p>
		  			</div>
          </div>
        </div>
      </LocaleProvider>
    )
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/home/Home.js